import { forwardRef, type InputHTMLAttributes } from 'react';

export interface InputTextProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  /** 入力タイプ（textベースのもの） */
  type?: 'text' | 'email' | 'tel' | 'url' | 'search' | 'number' | 'password';
  /** エラー状態 */
  error?: boolean;
  /** 追加のクラス名 */
  className?: string;
}

/**
 * AIPデザインシステムのテキスト入力コンポーネント
 */
export const InputText = forwardRef<HTMLInputElement, InputTextProps>(
  ({ type = 'text', error, className = '', ...props }, ref) => {
    const combinedClassName = `aip-floating-field__control aip-input-text ${className}`.trim();

    return (
      <input
        ref={ref}
        type={type}
        className={combinedClassName}
        aria-invalid={error || undefined}
        {...props}
      />
    );
  }
);

InputText.displayName = 'InputText';

export default InputText;

